exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".newsletter-form .btn{margin:20px auto;display:block;min-width:175px}@media screen and (min-width:959px){.newsletter-form .names{display:-webkit-box;display:-ms-flexbox;display:flex}.newsletter-form .names .input{-webkit-box-flex:1;-ms-flex:1;flex:1}}", ""]);

// exports
